module.exports = __webpack_public_path__ + "c5ebe0b32dc1b5cc449a76c4204d13bb.ttf";